const timesReload = function (seconds) {
  var hh
  var mm
  var ss
  if (seconds == null || seconds <= 0) {
    return '00:00:00'
  }
  hh = seconds / 3600 | 0
  seconds = parseInt(seconds) - hh * 3600
  if (parseInt(hh) < 10) {
    hh = '0' + hh
  }

  mm = seconds / 60 | 0

  ss = parseInt(seconds) - mm * 60
  if (parseInt(mm) < 10) {
    mm = '0' + mm
  }
  if (ss < 10) {
    ss = '0' + ss
  }
  return hh + ':' + mm + ':' + ss
}
const timesReload1 = function (seconds) {
  var mm
  var ss
  if (seconds == null || seconds <= 0) {
    return '00m00s'
  }
  mm = seconds / 60 | 0
  ss = parseInt(seconds) - mm * 60
  if (parseInt(mm) < 10) {
    mm = '0' + mm
  }
  if (ss < 10) {
    ss = '0' + ss
  }
  return mm + 'm' + ss + 's'
}
const timesReload2 = function (seconds) {
  var mm
  var ss
  if (seconds == null || seconds <= 0) {
    return '00:00'
  }
  seconds = parseInt(seconds)

  mm = seconds / 60 | 0
  ss = parseInt(seconds) - mm * 60
  if (parseInt(mm) < 10) {
    mm = '0' + mm
  }
  if (ss < 10) {
    ss = '0' + ss
  }
  return mm + ':' + ss
}
const dayReload = function (times) {
  if(!times) return ''
  const stamp1 = new Date(new Date().setHours(0, 0, 0, 0)); //获取当天零点的时间
  const stampNow = new Date(times)
  let year = stampNow.getFullYear()
  let month = stampNow.getMonth() + 1
  let day = stampNow.getDate()
  let hour = stampNow.getHours()
  let minutes = stampNow.getMinutes()
  if (month < 10) month = '0' + month;
  if (day < 10) day = '0' + day;
  if(minutes < 10) minutes = '0' + minutes;

  if(stampNow - stamp1 < 1000 * 60 * 60 * 24 && stampNow - stamp1 >0){
    return '今天 ' + hour + ':' + minutes
  } else if(stampNow - stamp1 >= 1000 * 60 * 60 * 24 && stampNow - stamp1 < 1000 * 60 * 60 * 24 * 2){
    return '明天 ' + hour + ':' + minutes
  }else if(stamp1.getFullYear()-year !== 0){
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes
  }else {
    return month + '-' + day + ' ' + hour + ':' + minutes
  }
}
const dayReload1 = function (times){
  if(!times)return('')
  let stampNow = new Date(times)
  let month = stampNow.getMonth() + 1
  let day = stampNow.getDate()
  let hour = stampNow.getHours()
  let minutes = stampNow.getMinutes()
  if (month < 10) month = '0' + month;
  if (day < 10) day = '0' + day;
  if(minutes < 10) minutes = '0' + minutes;
  return month + '-' + day + ' ' + hour + ':' + minutes
}
const dayReload2 = function (target) {                                  // 时间过滤
  var thisTime = target.replace('T', ' ')
  var lastTime = new Date(thisTime.replace(/-/g, "/"))
  lastTime = lastTime.getTime()
  var dateDiff = function (timestamp) {
    // 补全为13位
    var arrTimestamp = (timestamp + '').split('')

    for (var start = 0; start < 13; start++) {
      if (!arrTimestamp[start]) {
        arrTimestamp[start] = '0'
      }
    }
    timestamp = arrTimestamp.join('') * 1

    var minute = 1000 * 60
    var hour = minute * 60
    var day = hour * 24
    var halfamonth = day * 15
    var month = day * 30
    var now = new Date().getTime()
    var diffValue = now - timestamp
    // 如果本地时间反而小于变量时间
    if (diffValue < 0) {
      return '不久前'
    }
    // 计算差异时间的量级
    var monthC = diffValue / month
    var weekC = diffValue / (7 * day)
    var dayC = diffValue / day
    var hourC = diffValue / hour
    var minC = diffValue / minute
    // 数值补0方法
    var zero = function (value) {
      if (value < 10) {
        return '0' + value
      }
      return value
    }
    // 使用
    if (monthC > 12) {
      // 超过1年，直接显示年月日
      return (function () {
        var date = new Date(timestamp)
        return date.getFullYear() + '年' + zero(date.getMonth() + 1) + '月' + zero(date.getDate()) + '日'
      })()
    } else if (monthC >= 1) {
      return parseInt(monthC) + '月前'
    } else if (weekC >= 1) {
      return parseInt(weekC) + '周前'
    } else if (dayC >= 1) {
      return parseInt(dayC) + '天前'
    } else if (hourC >= 1) {
      return parseInt(hourC) + '小时前'
    } else if (minC >= 1) {
      return parseInt(minC) + '分钟前'
    } else {
      return '刚刚'
    }
  }
  return dateDiff(lastTime)
}
const numberReload = function (target) {
  target = Number(target)
  if (target < 1000) {
    return target
  }
  if (target >= 1000 && target < 10000) {
    let x = `${target / 1000}`
    if (x.indexOf('.') !== -1) {
      if ([...x.split('.')[1]][0] === '0') {
        return x.split('.')[0] + 'k+'
      } else {
        return x.split('.')[0] + '.' + [...x.split('.')[1]][0] + 'k+'
      }
    } else {
      return x + 'k+'
    }
  }
  if (target >= 10000 && target < 100000000) {
    let x = `${target / 10000}`
    if (x.indexOf('.') !== -1) {
      if ([...x.split('.')[1]][0] === '0') {
        return x.split('.')[0] + 'w+'
      } else {
        return x.split('.')[0] + '.' + [...x.split('.')[1]][0] + 'w+'
      }
    } else {
      return x + 'w+'
    }
  }
  if (target >= 100000000) {
    let x = `${target / 100000000}`
    if (x.indexOf('.') !== -1) {
      if ([...x.split('.')[1]][0] === '0') {
        return x.split('.')[0] + '亿+'
      } else {
        return x.split('.')[0] + '.' + [...x.split('.')[1]][0] + '亿+'
      }
    } else {
      return x + '亿+'
    }
  }
}
const splitUserName = (value) => {
  if (value.length <= 6) {
    return value
  } else {
    return value.substring(0, 6) + '...'
  }
}
const timeHidden = (lastTime, time) => {
  let time1 = new Date(lastTime).getTime()
  let time2 = new Date(time).getTime()
  if ((time2 - time1) >= 5 * 60 * 1000) {
    return time.replace('T', ' ')
  } else {
    return null
  }
}
const timeJoined = (joined_time) => {
  let time1 = new Date(joined_time).getTime()
  let time2 = new Date().getTime()

  return Math.ceil((time2 - time1)/(1000*3600*24))
}
const changeLimit = (limit) => {
  let size = (limit/(1024*1024)).toFixed(2)
  return size
}
const formatTel = (tel)=>{
  tel = "" + tel;
  return tel.substr(0, 3) + "****" + tel.substr(7);
}
const numberFilter = (value) =>{
  if (value === 0){
    return ''
  }
  if (value < 1000) {
    return value
  }
  if (value >= 1000 && value < 10000) {
    let x = `${value / 1000}`
    if (x.indexOf('.') !== -1) {
      if ([...x.split('.')[1]][0] === '0') {
        return x.split('.')[0] + 'k'
      } else {
        return x.split('.')[0] + '.' + [...x.split('.')[1]][0] + 'k'
      }
    } else {
      return x + 'k'
    }
  }
  if (value >= 10000 && value < 100000000) {
    let x = `${value / 10000}`
    if (x.indexOf('.') !== -1) {
      if ([...x.split('.')[1]][0] === '0') {
        return x.split('.')[0] + 'w'
      } else {
        return x.split('.')[0] + '.' + [...x.split('.')[1]][0] + 'w'
      }
    } else {
      return x + 'w'
    }
  }
  if (value >= 100000000) {
    let x = `${value / 100000000}`
    if (x.indexOf('.') !== -1) {
      if ([...x.split('.')[1]][0] === '0') {
        return x.split('.')[0] + '亿'
      } else {
        return x.split('.')[0] + '.' + [...x.split('.')[1]][0] + '亿'
      }
    } else {
      return x + '亿'
    }
  }
}

const transformTime = function(target){
  var thisTime = target.replace('T', ' ')
  var lastTime = new Date(thisTime.replace(/-/g, "/"))
  lastTime = lastTime.getTime()

  // window.alert(new Date(thisTime.replace(/-/g, "/")))
  var dateDiff = function (timestamp) {
    // 补全为13位
    var arrTimestamp = (timestamp + '').split('')

    for (var start = 0; start < 13; start++) {
      if (!arrTimestamp[start]) {
        arrTimestamp[start] = '0'
      }
    }
    timestamp = arrTimestamp.join('') * 1

    var minute = 1000 * 60
    var hour = minute * 60
    var day = hour * 24
    var halfamonth = day * 15
    var month = day * 30
    var now = new Date().getTime()
    var diffValue = now - timestamp

    // 如果本地时间反而小于变量时间
    if (diffValue < 0) {
      return '不久前'
    }
    // 计算差异时间的量级
    var monthC = diffValue / month
    var weekC = diffValue / (7 * day)
    var dayC = diffValue / day
    var hourC = diffValue / hour
    var minC = diffValue / minute

    // 数值补0方法
    var zero = function (value) {
      if (value < 10) {
        return '0' + value
      }
      return value
    }

    // 使用
    if (monthC > 12) {
      // 超过1年，直接显示年月日
      return (function () {
        var date = new Date(timestamp)
        return date.getFullYear() + '年' + zero(date.getMonth() + 1) + '月' + zero(date.getDate()) + '日'
      })()
    } else if (monthC >= 1) {
      return parseInt(monthC) + '月前'
    } else if (weekC >= 1) {
      return parseInt(weekC) + '周前'
    } else if (dayC >= 1) {
      return parseInt(dayC) + '天前'
    } else if (hourC >= 1) {
      return parseInt(hourC) + '小时前'
    } else if (minC >= 1) {
      return parseInt(minC) + '分钟前'
    } else {
      return '刚刚'
    }
  }
  return dateDiff(lastTime)
}

const yearFitStr = function(dateString) {
  const date = new Date(dateString);
  const year = date.getFullYear()

  if(year >= 2020){
    return '20后'
  }else if(year >= 2010){
    return '10后'
  }else if(year >= 2000){
    return '00后'
  }else if(year >= 1990){
    return '90后'
  }else if(year >= 1980){
    return '80后'
  }else if(year >= 1970){
    return '70后'
  }else if(year >= 1960){
    return '60后'
  }else if(year >= 1950){
    return '50后'
  }else if(year >= 1940){
    return '40后'
  }else if(year >= 1930){
    return '30后'
  }
  return yearFit+'年'

}

//根据年月日获取星座
const getZodiacSign = function(dateString) {
  const date = new Date(dateString);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) {
    return '水瓶座';
  } else if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) {
    return '双鱼座';
  } else if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) {
    return '白羊座';
  } else if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) {
    return '金牛座';
  } else if ((month === 5 && day >= 21) || (month === 6 && day <= 21)) {
    return '双子座';
  } else if ((month === 6 && day >= 22) || (month === 7 && day <= 22)) {
    return '巨蟹座';
  } else if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) {
    return '狮子座';
  } else if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) {
    return '处女座';
  } else if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) {
    return '天秤座';
  } else if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) {
    return '天蝎座';
  } else if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) {
    return '射手座';
  } else {
    return '摩羯座';
  }
}

export default {
  timesReload,
  timesReload1,
  timesReload2,
  dayReload,
  dayReload1,
  dayReload2,
  numberReload,
  splitUserName,
  timeHidden,
  timeJoined,
  changeLimit,
  formatTel,
  numberFilter,
  transformTime,
  yearFitStr,
  getZodiacSign,
}



// WEBPACK FOOTER //
// ./src/config/filter.js